<template>
    <div>
       <section>
         <VUEAppHeader style="z-index:999999;" :VisualizzaMenu="VisualizzaMenu" @onClickCambiaMenu="ClickCambiaMenu()"></VUEAppHeader>
         <section>
           <section class="hbox stretch">
             <VUEAppSideMenu :Altezza="Altezza"></VUEAppSideMenu>  
             <section id="content">
               <section class="vbox"  style="display:block;">          
                <section class="padder" style="overflow-y: scroll;" :style="{height: (Altezza - 50) + 'px'}">
                  <div v-if="TitoloPagina != ''" class="breadcrumb no-border no-radius b-b b-light">
                    <span class="ZMTitoloContenuti">{{TitoloPagina}}</span>
                  </div>
                  <VUEAppContentAggiungiMessaggio></VUEAppContentAggiungiMessaggio>
               </section>
               </section>
               <a href="#" class="hide nav-off-screen-block" data-toggle="class:nav-off-screen, open" data-target="#nav,html"></a>
             </section>
             <aside class="bg-light lter b-l aside-md hide" id="notes">
               <div class="wrapper">Notification</div>
             </aside>
           </section>
         </section>
       </section>
    </div>
   </template>
  
  <script>
  import VUEAppHeader from '@/components/FrameComponentsMultiPurpose/VUEAppHeader.vue';
  import VUEAppSideMenu from '../components/FrameComponentsMultiPurpose/VUEAppSideMenu.vue';
  import VUEAppContentAggiungiMessaggio from './ContentPages/VUEAppContentAggiungiMessaggio.vue';
  
  export default 
  {
      name: "VUEMessaggio",
      data() 
      {
       return {
                Altezza : document.documentElement.clientHeight,
                TitoloPagina : 'Messaggio',             
                VisualizzaMenu         : false,              
              };
      },
      components: 
      {
         VUEAppHeader,
         VUEAppSideMenu,
         VUEAppContentAggiungiMessaggio
      },
      methods: 
      {
        ClickCambiaMenu()
        {
          this.VisualizzaMenu = !this.VisualizzaMenu
        },
        getDimensions()
        {
            this.Altezza = document.documentElement.clientHeight;
        },
        AggiornaTipoPagina()
        {
          if (this.$route.params.pagina == 'nuovo')
            this.TitoloPagina = 'Nuovo Messaggio'
          else this.TitoloPagina = 'Aggiorna Messaggio'
        }
      },
      beforeMount()
      {
        this.AggiornaTipoPagina();
      },
      beforeUpdate()
      {
        this.AggiornaTipoPagina();
      },
      mounted() 
      {
        window.addEventListener('resize', this.getDimensions);
      },
      unmounted() 
      {
        window.removeEventListener('resize', this.getDimensions);
      },
  };
  </script>